module.exports = __webpack_public_path__ + "img/step2.21da71d0.png";